import { Container, Typography } from '@mui/material';
import Button from './button.component';

export function InfoContainer({
  title,
  description,
  button,
  nopadding,
}: {
  title?: string;
  description?: string;
  button?: {
    text: string;
    variant?: 'contained' | 'outlined' | 'text';
    color?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
    size?: 'small' | 'medium' | 'large';
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    onClick?: () => void;
    href?: string;
  };
  nopadding?: boolean;
}) {
  return (
    <Container
      sx={{
        textAlign: 'center',
        py: nopadding ? 0 : 3,
      }}
    >
      {title ? (
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
      ) : null}
      {description ? (
        <Typography variant="body1" gutterBottom>
          {description}
        </Typography>
      ) : null}
      {button ? (
        <Button
          variant={button.variant}
          color={button.color}
          size={button.size}
          startIcon={button.startIcon}
          endIcon={button.endIcon}
          onClick={button.onClick}
          href={button.href}
        >
          {button.text}
        </Button>
      ) : null}
    </Container>
  );
}
